import { useReveal } from "../../lib/hooks";

const VEDAS = [
  {
    deva: "ऋग्वेद",
    name: "Ṛgveda",
    epithet: "The Veda of praise",
    body: "The oldest and most fundamental of the four. 1,028 hymns — sūktas — gathered into ten maṇḍalas and addressed to the deities and cosmic powers.",
    figure: "1,028 hymns",
  },
  {
    deva: "यजुर्वेद",
    name: "Yajurveda",
    epithet: "The Veda of ritual",
    body: "A liturgical manual: prose mantras and verses spoken in the yajña and other sacred ceremonies, where word and action meet in offering.",
    figure: "~1,975 mantras",
  },
  {
    deva: "सामवेद",
    name: "Sāmaveda",
    epithet: "The Veda of song",
    body: "The book of melodies. 1,549 verses, mostly drawn from the Ṛgveda and set to the sāman — the chants that carry the mantra in tone and rhythm.",
    figure: "1,549 verses",
  },
  {
    deva: "अथर्ववेद",
    name: "Atharvaveda",
    epithet: "The Veda of daily life",
    body: "Around 730 hymns and 6,000 mantras for the everyday — health, family, prosperity, protection — bringing the sacred into the conduct of ordinary life.",
    figure: "~6,000 mantras",
  },
] as const;

export function FourVedas() {
  const { ref } = useReveal<HTMLDivElement>();

  return (
    <section className="py-20 md:py-28 bg-[var(--color-vellum-dim)] border-y border-[var(--color-rule)]">
      <div className="container-edit">
        <div className="section-heading">
          <span className="section-heading-num tabular">04 / The four Vedas</span>
          <hr className="rule flex-1 hidden sm:block" />
        </div>

        <h2 className="font-display text-[clamp(2.5rem,6vw,5rem)] leading-[1.02] tracking-[-0.02em] mb-14 md:mb-16 max-w-[16ch]">
          Four collections —{" "}
          <span className="font-display-italic" style={{ color: "var(--color-violet)" }}>
            one
          </span>{" "}
          inheritance.
        </h2>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-px bg-[var(--color-rule)] border border-[var(--color-rule)] rounded-[var(--radius-card)] overflow-hidden reveal-stagger">
          {VEDAS.map((v, idx) => (
            <article
              key={v.name}
              className="veda-card"
              style={{ minHeight: "26rem" }}
            >
              <header className="flex items-baseline justify-between mb-8">
                <span className="font-grotesk text-[0.7rem] tracking-[0.22em] uppercase text-[var(--color-ink-mute)] tabular">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <span className="font-grotesk text-[0.7rem] tracking-[0.22em] uppercase text-[var(--color-violet)]">
                  {v.figure}
                </span>
              </header>
              <span className="veda-card-deva">{v.deva}</span>
              <h3 className="font-display text-[2rem] tracking-tight leading-tight">
                {v.name}
              </h3>
              <p className="font-display-italic text-[1.0625rem] text-[var(--color-ink-mute)] mt-1 mb-5">
                {v.epithet}
              </p>
              <hr className="rule mb-5 max-w-[2rem]" />
              <p className="text-[0.95rem] leading-[1.65] text-[var(--color-ink-soft)]">
                {v.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
